import { render, staticRenderFns } from "./FestivalDailySchedule.vue?vue&type=template&id=2643f174&scoped=true"
import script from "./FestivalDailySchedule.vue?vue&type=script&lang=js"
export * from "./FestivalDailySchedule.vue?vue&type=script&lang=js"
import style0 from "./FestivalDailySchedule.vue?vue&type=style&index=0&id=2643f174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2643f174",
  null
  
)

export default component.exports